<template>
	<edit :classify="classify" :classify-name="classifyName" :apply-is-virtual="isVirtual"></edit>
</template>

<script>
	import edit from './product_edit.vue'
	
	export default {
		name: 'product_apply',
		
		props: {
			classify: String,
			classifyName: String,
            isVirtual: String
		},
		
		components: {
			edit
		}
	}
</script>